import React from "react";
import styled from "styled-components";
import { CollapsibleSection } from './common/CollapsibleSection';
import { URLQRForm } from './qrform/URLQRForm';
import { EmailQRForm } from './qrform/EmailQRForm';
import { QRData } from '../types/qr';
import { HandleInputChangeFunction } from './QRCodeGenerator';
import { PDFQRForm } from './qrform/PDFQRForm';
import { ImageQRForm } from './qrform/ImageQRForm';
import { VideoQRForm } from './qrform/VideoQRForm';
import { WiFiQRForm } from './qrform/WiFiQRForm';
import { TwitterQRForm } from './qrform/TwitterQRForm';
import { FacebookQRForm } from './qrform/FacebookQRForm';

export interface QRCodeFormProps {
  qrType: keyof QRData;
  qrData: QRData;
  handleInputChange: HandleInputChangeFunction;
  placeholder: string;
  handleAddLink?: () => void;
  userChoice: "qr" | "dynamicBio" | null;
  isDynamicQR: boolean;
}

export const QRCodeForm: React.FC<QRCodeFormProps> = ({
  qrType,
  qrData,
  handleInputChange,
  placeholder,
  handleAddLink,
  userChoice,
  isDynamicQR,
}) => {
  const renderFormContent = () => {
    switch (qrType) {
      case "url":
        return <URLQRForm 
          qrData={qrData} 
          handleInputChange={handleInputChange} 
          isDynamicQR={isDynamicQR} 
        />;
      case "email":
        return <EmailQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "pdf":
        return <PDFQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "image":
        return <ImageQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "video":
        return <VideoQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "wifi":
        return <WiFiQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "twitter":
        return <TwitterQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      case "facebook":
        return <FacebookQRForm qrData={qrData} handleInputChange={handleInputChange} />;
      default:
        return null;
    }
  };

  return (
    <Section>
      <CollapsibleSection 
        title={
          <SubSectionTitle>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
              <rect width="256" height="256" fill="none"/>
              <rect x="16" y="104" width="48" height="48" rx="8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
              <rect x="152" y="40" width="64" height="64" rx="8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
              <rect x="152" y="152" width="64" height="64" rx="8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
              <line x1="64" y1="128" x2="112" y2="128" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
              <path d="M152,184H128a16,16,0,0,1-16-16V88a16,16,0,0,1,16-16h24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
            </svg>
            {`Configure QR Data: ${qrType}`}
          </SubSectionTitle>
        }
        defaultOpen={true}
      >
        {renderFormContent()}
      </CollapsibleSection>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 24px;
`;

const SubSectionTitle = styled.h3`
  font-size: 1rem;
  color: #333;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 20px;
    height: 20px;
    color: #333;
  }
`;